import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
// import {
//   CustomQuery
// } from '@vue-storefront/core';
import { useApiError } from '../useApiError';

export const useClaimBenfitCode = (id: string): any => {
    const { set: setError } = useApiError();
    const context = useVSFContext();
    const claimResult = sharedRef(null, `useClaimBenfitCode-claimResult-${id}`);
    const claimError = sharedRef(null, `useClaimBenfitCode-claimError-${id}`);
    // Shared ref holding errors from the methods
    const claimBenefitCode = async (customQuery) => {
        try {
            const query = JSON.parse(JSON.stringify(customQuery));
            delete query.auto;
            const res = await context.$xbuy.api.claimBenefitCode(query);
            if (res && res.code === 0) {
                claimResult.value = res.data;
                claimError.value = null;
            } else if (customQuery && !customQuery.auto) {
                setError(res);
                claimError.value = new Error(res.message);
            }
            return res;
        } catch (err) {
            claimError.value = err;
            setError({ code: 99999, err });
        }
    };
    return {
        claimBenefitCode: claimBenefitCode,
        // loading: computed(() => loading.value),
        claimResult: computed(() => claimResult.value),
        claimError: computed(() => claimError.value)
    };
};
